import { SessionInfo } from 'auth/types';
import { createContext } from 'react';

export default createContext<SessionInfo>({ userTenants: [] });
